import { gql } from '@apollo/client';
const defaultSchemaProps = `
  id
  identifier
  properties
  dynamicProperties
  actions
  interfaces
  relations
  __typename
`;
const getEntitySchema = gql`
  query getEntitySchema($id: String!) {
    getEntitySchema: getEntitySchema(id: $id) {
      ${defaultSchemaProps}
    }
  }
`;
const getEntityData = (action, props) => gql`
  query getEntityData($id: String!){
    entityData: ${action}(id: $id){
    ${props},
    id,
    __typename
    }
  }
  `;
export { getEntitySchema, getEntityData };
//# sourceMappingURL=index.js.map